/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { compose } from "redux";
import createSagaMiddleware from "redux-saga";

import { configureStore } from "@reduxjs/toolkit";

import { getCountryRegion } from "Dataflows/CountryRegion/CountryRegionAction";
import { awardCategoriesApi } from "Services/AwardCategoriesApi";
import { manageCodesApi } from "Services/ManageCodesApi";
import { benefitManagementApi } from "Services/BenefitManagementApi";

import rootReducer from "../Dataflows/Reducers";
import watchAll from "../Dataflows/Sagas";

const sagaMiddleware = createSagaMiddleware();

// TODO: Figure out how we are going to run it in Production
declare global {
  // eslint-disable-next-line @typescript-eslint/interface-name-prefix
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({
      thunk: true,
      serializableCheck: false,
    })
      .concat(sagaMiddleware)
      .concat(awardCategoriesApi.middleware)
      .concat(manageCodesApi.middleware)
      .concat(benefitManagementApi.middleware),
});

sagaMiddleware.run(watchAll);

store.dispatch(getCountryRegion());

export default store;
export type AppState = ReturnType<typeof rootReducer>;
